// import axios from 'axios';

// const specialCharsMap = {
//     "'": "%27",
//     '"': "%22",
//     ';': "%3B",
//     '--': "%2D%2D",
//     '#': "%23",
//     '(': "%28",
//     ')': "%29",
//     '=': "%3D",
//     'UNION': "UN%49ON",
//     'SELECT': "SE%4CECT",
//     'DELETE': "DE%4CETE",
//     'DROP': "DR%4FP",
//     'UPDATE': "UP%44ATE",
//     '%': "%25",
//     '\\': "%5C",
//     '~': "%7E",
//     '<': "%3C",
//     '>': "%3E",
//     '+': "%2B",
//     '/': "%2F",
//     '^': "%5E",
//     '&': "%26",
//     '|': "%7C",
//     '@': "%40",
//     '.': "%2E",
//     ',': "%2C",
//     '?': "%3F",
//     '!': "%21",
//     '*': "%2A",
//     '{': "%7B",
//     '}': "%7D",
//     '[': "%5B",
//     ']': "%5D",
//     '`': "%60",
//     '$': "%24",
//     ':': "%3A",
//     ' ': "%20",
//     '\n': "%0A",
//     '\r': "%0D",
//     '\t': "%09",
//     '_': "%5F"
// };

// export const encodeSpecialChars = (data) => {
//     const encodeValue = (value) => {
//       if (typeof value === 'string') {
//         // Create a single regex pattern for all special characters
//         const pattern = Object.keys(specialCharsMap)
//           .sort((a, b) => b.length - a.length) // Sort by length (longest first)
//           .map(key => key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')) // Escape regex special chars
//           .join('|');

//         return value.replace(new RegExp(pattern, 'g'), match => specialCharsMap[match]);
//       }
//       return value;
//     };

//     const encodeObject = (obj) => {
//       if (obj === null || obj === undefined) {
//         return obj;
//       }

//       if (Array.isArray(obj)) {
//         return obj.map(item => encodeObject(item));
//       }

//       if (typeof obj === 'object') {
//         const encoded = {};
//         Object.keys(obj).forEach(key => {
//           encoded[key] = encodeObject(obj[key]);
//         });
//         return encoded;
//       }

//       return encodeValue(obj);
//     };

//     return encodeObject(data);
// };

// // Create axios interceptor to handle all requests
// axios.interceptors.request.use((config) => {
//     try {
//         // Handle request body for POST, PUT, PATCH
//         if (config.data && ['post', 'put', 'patch'].includes(config.method?.toLowerCase())) {
//             config.data = encodeSpecialChars(config.data);
//         }

//         // Handle URL params for all requests
//         if (config.params) {
//             config.params = encodeSpecialChars(config.params);
//         }

//         return config;
//     } catch (error) {
//         console.error('Encoding error:', error);
//         return config;
//     }
// }, (error) => {
//     return Promise.reject(error);
// });

// // Handle response if needed
// axios.interceptors.response.use((response) => {
//     return response;
// }, (error) => {
//     return Promise.reject(error);
// });


import axios from 'axios';
import { handleLogoutAndRedirect } from '../redux/api';

var SSO_URL_TO_EXCLUDE = 'oauth_login'

export const encodeSpecialChars = (data) => {
  const encodeValue = (value) => {
    if (typeof value === 'string') {
      // Custom encoding that preserves % character
      return value.split('').map(char => {
        if (char === '%') {
          return char; // Keep % as is
        }
        return encodeURIComponent(char);
      }).join('');
    }
    return value;
  };

  const encodeObject = (obj) => {
    if (obj === null || obj === undefined) {
      return obj;
    }

    if (Array.isArray(obj)) {
      return obj.map(item => encodeObject(item));
    }

    if (typeof obj === 'object') {
      const encoded = {};
      Object.keys(obj).forEach(key => {
        encoded[key] = encodeObject(obj[key]);
      });
      return encoded;
    }

    return encodeValue(obj);
  };

  return encodeObject(data);
};

// Create axios interceptor to handle all requests
axios.interceptors.request.use((config) => {
  try {
    if (!config.url.includes(SSO_URL_TO_EXCLUDE)) {
      // Handle request body for POST, PUT, PATCH
      if (config.data && ['post', 'put', 'patch'].includes(config.method?.toLowerCase())) {
        config.data = encodeSpecialChars(config.data);
      }

      // Handle URL params for all requests
      if (config.params) {
        config.params = encodeSpecialChars(config.params);
      } else if (config.url && config.url.includes('?')) {
        // If params are in URL, extract and encode them
        const [baseUrl, queryString] = config.url.split('?');
        const params = {};
        queryString.split('&').forEach(param => {
          const [key, value] = param.split('=');
          params[key] = value;
        });
        config.params = encodeSpecialChars(params);
        config.url = baseUrl;
      }
    }

    return config;
  } catch (error) {
    console.error('Encoding error:', error);
    return config;
  }
}, (error) => {
  return Promise.reject(error);
});

// Handle response if needed
axios.interceptors.response.use((response) => {
  return response;
}, (error) => {
  if (!error || error.status !== 401) return Promise.reject(error);

  if (error.status === 401 && error?.data?.message?.toLowerCase().includes("expired")) {
    handleLogoutAndRedirect("Session Expired. Please log in.");
  }
  return Promise.reject(error);
});